import { render } from "./faqs.vue?vue&type=template&id=3325ba53&scoped=true"
import script from "./faqs.vue?vue&type=script&lang=js"
export * from "./faqs.vue?vue&type=script&lang=js"

import "./faqs.vue?vue&type=style&index=0&id=3325ba53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3325ba53"

export default script